import React, {Component} from 'react';
import { connect } from 'react-redux' 
// Components
import FAQForm from 'components/presentational/FAQForm';
import FAQResults from 'components/presentational/FAQResults';
import { Link } from 'react-router-dom';
// Files
import FAQContent from './FAQContent.json';
import './faq-section.scss';
// Functions 
import { addNumberIsIntegerPolyfill } from 'components/functions';
import { triggerGTMPush } from 'redux/actions';

class FAQSection extends Component {
    constructor() {
        super();
        this.componentData = FAQContent;
        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGoBack = this.handleGoBack.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleRadioBtnChange = this.handleRadioBtnChange.bind(this);
        this.handleNoneApplySubmit = this.handleNoneApplySubmit.bind(this)
        
        this.state = {
            formIsSubmitted: false,
            formItems: this.componentData.map((item, id) => ({
                id,
                question: item.question,
                extraQuestion: item.extraQuestion,
                options: item.options,
                isActive: false,
                activeOption: undefined
            })),
            resultItems: [],
            formIsValid: false,
            subAnswers: ''
        }

        addNumberIsIntegerPolyfill(); // Required for IE 11
    }
    
    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            subAnswers:  '',
            formIsSubmitted: true,
            resultItems: this.state.formItems.filter(item => item.isActive)
                .map(item => {                                                                    
                    const answer = this.componentData[item.id].options ?
                            this.componentData[item.id].options[item.activeOption].answer :
                            this.componentData[item.id].answer;

                    const label = this.componentData[item.id].options ?
                            this.componentData[item.id].options[item.activeOption].label :
                            this.componentData[item.id].label;                                                    
                    return {
                        question: item.question,                        
                        label,
                        answer: answer
                    }
                }),
        }, () => {
          const answersGTM = this.state.resultItems.map((result) => 
                result.label 
          ).join(', ');

          const subAnswersGTM = this.state.resultItems.filter((item) => item.answer)
          .map((result) => 
              result.answer 
        ).join(', ');
                    
          // answers for parent questions
          this.props.triggerGTMPush({
            'event': 'quizSubmit',
            'quizAnswer': answersGTM,
            'subQuizAnswer': subAnswersGTM && subAnswersGTM.length > 0 
                && answersGTM && answersGTM.length > 0 ? 
                subAnswersGTM : undefined
          });                                      
        });
    }
    
    validateTheForm() {
        let copy = this.state.formItems.filter(item => item.isActive);
        let formIsValid = !!copy.length;
        
        copy.map(item => {
            if (item.options && !Number.isInteger(item.activeOption) ) {
                formIsValid = false
            } 
            return false
        });
        
        this.setState({
            formIsValid
        })
    }
    
    handleGoBack(event) {
        event.preventDefault();
        this.setState({formIsSubmitted: false});
    }
    
    handleCheckboxChange(event) {
        const checkbox = event.target;
        const checkboxId = parseInt(checkbox.getAttribute("data-id"), 10);
        this.toggleCheckbox(checkboxId);
        this.validateTheForm();
    }
    
    toggleCheckbox(id) {
        this.setState({
            formItems: this.state.formItems.map((item, index) => {
                if (index === id) item.isActive = !item.isActive
                return item
            })
        });
    }
    
    handleRadioBtnChange(event) {
        const checkbox = event.target;
        const itemId = parseInt(checkbox.getAttribute("data-id"), 10);
        const optionId = parseInt(checkbox.getAttribute("data-option"), 10);
        this.toggleRadioButton(itemId, optionId);
        this.validateTheForm();
    }
    
    toggleRadioButton(itemId, optionId) {
        this.setState({
            formItems: this.state.formItems.map((item, index) => {
                if (index === itemId) {
                    item.activeOption = optionId
                }
                return item
            })
        });
    }
    
    handleNoneApplySubmit() {
      this.props.triggerGTMPush({
        'event': 'quizSubmit',
        'quizAnswer': 'None apply to me'
      })
    }
    
    render() {
        return (
            <div className="faq-section">
                <div className="faq-section__body">
                    {!this.state.formIsSubmitted ? 
                        (
                            <FAQForm handleSubmit={this.handleSubmit} 
                                formItems={this.state.formItems}
                                handleCheckboxChange={this.handleCheckboxChange}
                                handleRadioBtnChange={this.handleRadioBtnChange} 
                                formIsValid={this.state.formIsValid} /> 
                        ) : (
                            <FAQResults handleGoBack={this.handleGoBack} 
                                resultItems={this.state.resultItems}/> 
                        )
                    }
                </div>
                
                <div className="faq-section__next-section">
                    <Link to="/step-3/" onClick={this.handleNoneApplySubmit} className="faq-section__link">None&nbsp;applies&nbsp;to&nbsp;me. Move&nbsp;to&nbsp;next&nbsp;section&nbsp;&gt;</Link>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
    triggerGTMPush: (eventData) => dispatch(triggerGTMPush(eventData))
  }
}

export default connect(null, mapDispatchToProps)(FAQSection);
